var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.668 14c0-4.4 0-6.6 1.367-7.967S9.602 4.666 14 4.666c4.4 0 6.6 0 7.967 1.367s1.367 3.567 1.367 7.966c0 4.4 0 6.6-1.367 7.967S18.4 23.333 14 23.333s-6.6 0-7.966-1.367-1.367-3.567-1.367-7.967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.75 17.5 2.149-6.447a.81.81 0 0 1 1.536 0l2.148 6.447m-4.666-2.333h3.5M18.082 10.5v7M9.332 2.334v2.333m9.333-2.333v2.333M14 2.334v2.333M9.332 23.334v2.333m4.667-2.333v2.333m4.666-2.333v2.333m7-7h-2.333M4.665 9.334H2.332m2.333 9.333H2.332m2.333-4.666H2.332m23.333-4.667h-2.333m2.333 4.667h-2.333"
  })));
};
export default SvgAi;